module.exports = __webpack_public_path__ + "img/asnafil.ac2e974a.jpg";